import React, { useState } from 'react';

import PermissionTooltip from '@dashboard/components/PermissionTooltip';
import { useDomainNameVerificationsQuery } from '@dashboard/generated/wp/platform';
import { Button, Tooltip } from '@mui/material';

import { usePermission } from '../../hooks';

import FormDialog from './FormDialog';

export default function CreateVerifiedEmailAddressDialog() {
  const [open, setOpen] = useState(false);
  const { data } = useDomainNameVerificationsQuery();
  const model = data?.DomainNameVerifications;

  const permission = usePermission('createVerifiedEmailAddress');
  if (!permission) {
    return (
      <PermissionTooltip span name="createVerifiedEmailAddress">
        <Button disabled type="button" variant="outlined">
          Add
        </Button>
      </PermissionTooltip>
    );
  }

  if (model === undefined) {
    return (
      <Button disabled type="button" variant="outlined">
        Add
      </Button>
    );
  }

  if (model.count === 0) {
    return (
      <Tooltip title="A verified domain is required to add a sender.">
        <span>
          <Button disabled type="button" variant="outlined">
            Add
          </Button>
        </span>
      </Tooltip>
    );
  }

  const initialValues = { domainNameVerificationId: model.nodes[0].id };
  const dialog = open ? <FormDialog initialValues={initialValues} onClose={() => setOpen(false)} /> : null;
  return (
    <>
      <Button onClick={() => setOpen(true)} type="button" variant="outlined">
        Add
      </Button>
      {dialog}
    </>
  );
}
